import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Checkbox } from 'site-modules/shared/components/checkbox/checkbox';

const DataPrivacyCheckboxUI = (props, ref) => {
  const innerRef = useRef();

  useImperativeHandle(ref, () => ({
    ...innerRef.current,
    value: innerRef.current && innerRef.current.checked,
  }));

  return <Checkbox ref={innerRef} {...props} />;
};

export const DataPrivacyCheckbox = forwardRef(DataPrivacyCheckboxUI);
